import { Button } from "react-bootstrap";
import { IoPaperPlaneOutline } from "react-icons/io5";

interface PrimarySmallButtonProps {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  icon?: React.ReactNode;
  compact?: boolean;
}

const PrimarySmallButton = ({ 
  onClick, 
  disabled = false, 
  children,
  icon = <IoPaperPlaneOutline />,
  compact = false,
}: PrimarySmallButtonProps) => {
  return (
    <Button
      onClick={onClick}
      className="rounded"
      size="sm"
      disabled={disabled}
      style={{
        padding: compact ? "4px 10px" : "6px 19px",
        fontSize: compact ? "11px" : undefined,
        fontWeight: compact ? 500 : "bold",
        boxShadow: "0 1px 2px rgba(31, 50, 96, 0.12)",
        display: "flex",
        alignItems: "center",
        gap: compact ? "4px" : "6px",
        backgroundColor: "#1f3260",
        borderColor: "#1f3260",
        borderWidth: "1px",
        borderStyle: "solid",
        color: "#ffffff",
        transition: "all 0.2s ease",
        cursor: disabled ? "not-allowed" : "pointer"
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = "#2a4378";
          e.currentTarget.style.borderColor = "#2a4378";
          e.currentTarget.style.transform = "translateY(-1px)";
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = "#1f3260";
          e.currentTarget.style.borderColor = "#1f3260";
          e.currentTarget.style.transform = "translateY(0)";
        }
      }}
    >
      {icon}
      {children}
    </Button>
  );
};

export default PrimarySmallButton;
